// Localized URL helpers. Internal language codes stay "ua|de|en|pl|ru";
// URLs use ISO codes "/uk|/de|/en|/pl|/ru".
export const URL_LANGS = ["de", "uk", "en", "pl", "ru"];
export const DEFAULT_LANG = "de";
export const STORAGE_KEY = "puregloss_lang";

export const langToUrl = (lang) => (lang === "ua" ? "uk" : lang);
export const urlToLang = (code) => (code === "uk" ? "ua" : code);

const INTERNAL = ["ua", "de", "en", "pl", "ru"];
const PREFIX_RE = /^\/(de|uk|en|pl|ru)(?=\/|$)/;

export const splitPath = (pathname = "/") => {
  const m = pathname.match(PREFIX_RE);
  if (!m) return { urlLang: null, rest: pathname };
  return { urlLang: m[1], rest: pathname.slice(m[0].length) || "/" };
};

export const localizedPath = (lang, rest = "/") => {
  const clean = rest.startsWith("/") ? rest : `/${rest}`;
  return `/${langToUrl(lang)}${clean}`;
};

export const storedLang = () => {
  try {
    const v = localStorage.getItem(STORAGE_KEY);
    return INTERNAL.includes(v) ? v : null;
  } catch {
    return null;
  }
};

export const browserLang = () => {
  if (typeof navigator === "undefined") return null;
  const list = navigator.languages && navigator.languages.length ? navigator.languages : [navigator.language];
  for (const raw of list) {
    const base = String(raw || "").toLowerCase().split("-")[0];
    if (base === "uk" || base === "ua") return "ua";
    if (INTERNAL.includes(base)) return base;
  }
  return null;
};

// Explicit choice > browser preference > German.
export const preferredLang = () => storedLang() || browserLang() || DEFAULT_LANG;

export const initialLang = () => {
  if (typeof window === "undefined") return DEFAULT_LANG;
  const { urlLang } = splitPath(window.location.pathname);
  return urlLang ? urlToLang(urlLang) : preferredLang();
};
